import initializeMobileMenu from './menu';
import initializeFiles from './blocks/files';
import initializeFancyBox from './fancybox';
import initializeForm from './utils/form';
import initializeLazyYoutube from "./utils/lazy-youtube";
import initializeStickyHeader from './utils/sticky-header';
import initializeGallerySlider from './blocks/gallery-slider';
import initializeOffersSlider from './blocks/offers-slider';
import initializeHero from './blocks/hero';
class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 1000
            });
        });
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeFiles();
        initializeLazyYoutube();
        initializeStickyHeader();
        initializeGallerySlider();
        initializeOffersSlider();
        initializeHero();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
